import { PartState } from '../types';
import { straightOnState } from './straight-on';

/**
 * Waving state — Bizy facing straight on with right arm raised up
 * and angled outward in a friendly wave. Left arm stays down.
 */
export const wavingState: PartState = {
	...straightOnState,
	arms: [
		// Left arm hangs down naturally
		{ d: 'M107.22 139L101.6 166.7C101.42 167.59 101.03 168.42 100.47 169.12L91.85 179.87', side: 'left' },
		// Right arm raised — shorter, waving position
		{ d: 'M201 135L210 112C211 109 213 106 215 104L222 96', side: 'right' },
	],
};
